import { useQuery } from "@tanstack/react-query";

const useNoRtl = (checkOriginQuery) => {
  const { data } = useQuery({
    queryKey: ["no-rtl"],
    queryFn: async () => {
      const noRtl = new URLSearchParams(window.location.search).get("no-rtl");
      if (noRtl === "true" && checkOriginQuery === "pdp") {
        window.sessionStorage.setItem("no-rtl", "true");
        return true;
      } else {
        return window.sessionStorage.getItem("no-rtl") === "true";
      }
    },
  });
  return data;
};
export default useNoRtl;
